import { render } from "./TopicInList.vue?vue&type=template&id=b1b4257a&scoped=true"
import script from "./TopicInList.vue?vue&type=script&lang=js"
export * from "./TopicInList.vue?vue&type=script&lang=js"

import "./TopicInList.vue?vue&type=style&index=0&id=b1b4257a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b4257a"]])

export default __exports__